import React from 'react'
import type { ArticleContentType } from '../../models/types'

const BorneFrame = (props: ArticleContentType): JSX.Element => {
  return (
    <React.Fragment>
      <div className='rf-px-6 large:rf-px-8 rf-w-full rf-mb-4 large:rf-mb-0 rf-flex rf-flex-col rf-border-r rf-border-r-silver vertical:rf-border-r-0'>
        {/* Title + category */}
        {props.title}

        <div className='rf-flex rf-flex-col large:rf-flex-row desktop:rf-h-full'>
          {/* Text + other data */}

          {/* Media + comment if there is at least one media or comment */}
        </div>
      </div>
    </React.Fragment>
  )
}

export default BorneFrame
